"use client";

import React from "react";
import Link from "next/link";

//Type
import { InformativeMessageProps } from "@/types";

//Styled
import * as S from "./styles";

//Icon
import { Info } from "lucide-react";

const InformativeMessage: React.FC<InformativeMessageProps> = ({
  className,
  title,
  message,
  icon,
  linkText,
  linkUrl,
  linkOnClick,
  linkExternal = false,
  variant = "info",
  heightContain = true,
}) => {
  const defaultIcon = <Info />;

  const renderLink = () => {
    if (!linkText) return null;

    if (linkOnClick) {
      return (
        <S.ActionButton onClick={linkOnClick} $variant={variant}>
          {linkText}
        </S.ActionButton>
      );
    }

    if (linkUrl) {
      if (linkExternal) {
        return (
          <S.ExternalLink
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            $variant={variant}
          >
            {linkText}
          </S.ExternalLink>
        );
      }

      return (
        <S.InternalLink href={linkUrl} $variant={variant}>
          {linkText}
        </S.InternalLink>
      );
    }

    return null;
  };

  return (
    <S.Container
      className={className}
      $heightContain={heightContain}
      $variant={variant}
    >
      <S.IconContainer $variant={variant}>
        {icon || defaultIcon}
      </S.IconContainer>

      {title && <S.Title $variant={variant}>{title}</S.Title>}

      <S.Message $variant={variant}>{message}</S.Message>

      {renderLink()}
    </S.Container>
  );
};

export default InformativeMessage;
